import { environment } from "src/environments/environment.prod";

/** @description Declare and initialize all the constant for the app here.  
*/
export class AppConstants {
    public static FIREBASE_SERVER_KEY: String = "AAAAIb10GFU:APA91bEf79lIr_hm0X5t0bYComQYkbmDtov0WomN0Dw6L5_59_FRd97twFeOIuJEbWugJwHcPebNyuPeg_a2OKmiRfEdQ6_ZndD-4jcDj1timYX_QUqvXjYrWvbqvU19n02wSzTwC__C";
    public static AUTH_TOKEN_STRING: string = "Authorization";
    public static BEARER_STRING: string = "Bearer ";//One blank space at last is needed, dont delete
    public static DELETE_MSG = "Delete";
    
    public static ACTIVE_STATUS: string = "Active";
    public static DEACTIVE_STATUS: string = "Deactive";

    public static ACTIVATE_MSG = "Activate";
    public static DEACTIVATE_MSG = "Deactivate";

    public static INVALID_FORM_MSG: string = 'Please Enter The valid Details';
    public static UPLOAD_MSG: string = 'Uploaded Successfully';
    public static UPDATED_MSG: string = 'Updated Successfully';

    public static NO_DATA_FOUND: string = 'No Data Found';
    static readonly DOWNLOAD_TEMPLATE_BASE_LINK = environment.baseTemplateDownloadUrl;

}